// NA Automobile contact constants & helpers
export const COMPANY = {
  name: "NA Automobile",
  legal: "Nazmi Asani e.U.",
  owner: "Nazmi Asani",
  address: "Logistikstraße 7 / Halle D",
  zipCity: "2201 Hagenbrunn",
  country: "Österreich",
  phone: "+43 667 7777686",
  phoneTel: "+436677777686",
  whatsapp: "436677777686",
  email: "office@naautomobile.at",
  vat: "ATU82640938",
  domain: "naautomobile.at",
  hours: {
    weekday: "Mo–Fr: 09:00–18:00",
    sat: "Sa: Nach Vereinbarung",
    sun: "So: Geschlossen",
  },
};

export const LOGO_URL = "/na-logo.svg";
export const LOGO_URL_DARK = "/na-logo-dark.svg";

export const buildWhatsappUrl = (text) => {
  const encoded = encodeURIComponent(text);
  return `https://wa.me/${COMPANY.whatsapp}?text=${encoded}`;
};

// Robustly open the WhatsApp link in a real top-level tab even when the app
// is rendered inside an iframe (e.g. preview environments). Without this, the
// browser may block the wa.me → api.whatsapp.com redirect with
// ERR_BLOCKED_BY_RESPONSE.
export const openWhatsapp = (text) => (e) => {
  if (e && typeof e.preventDefault === "function") e.preventDefault();
  const url = buildWhatsappUrl(text);
  if (typeof window !== "undefined") {
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (win) win.opener = null;
  }
};

export const phoneHref = `tel:${COMPANY.phoneTel}`;
export const emailHref = `mailto:${COMPANY.email}`;

export const WA_MESSAGES = {
  general: "Hallo NA Automobile, ich habe Ihre Website gesehen und hätte eine Frage.",
  contact: "Hallo NA Automobile, ich habe Ihre Website gesehen und möchte mich erkundigen.",
  vehicleInterest: (vehicleName) =>
    `Hallo NA Automobile, ich interessiere mich für dieses Fahrzeug: ${vehicleName}. Ist es noch verfügbar?`,
  vehicleDetail: (vehicleName) =>
    `Hallo NA Automobile, ich interessiere mich für ${vehicleName} auf naautomobile.at. Ist das Fahrzeug noch verfügbar?`,
  sellCar:
    "Hallo NA Automobile, ich möchte mein Fahrzeug verkaufen. Ich habe die Daten auf der Website eingegeben und bitte um eine erste Einschätzung.",
  financing: (label) =>
    `Hallo NA Automobile, ich interessiere mich für eine Finanzierung für ${label}. Bitte um Rückmeldung.`,
};

export const formatEUR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "";
  return new Intl.NumberFormat("de-AT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);
};

export const formatKM = (n) => {
  if (!n && n !== 0) return "";
  return `${new Intl.NumberFormat("de-AT").format(n)} km`;
};
